import useTranslate from 'app/i18n/useTranslate';

import type { FLOATING_RESOURCE_ADD_MENU_OPTION } from 'components/FloatingResourceAddMenu/hooks/useData/constants';

const useTranslation = () => {
    const t = useTranslate('floatingResourceContainerFooter');

    return {
        FORM_SELECTION: t('formSelection'),
        NEW_FORM_LINK_TEXT: (resource: FLOATING_RESOURCE_ADD_MENU_OPTION) =>
            t('newFormLinkText', { resource })
    };
};

export default useTranslation;
